import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Box
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import {
  fetchallcitylist,
  fetchAttendance,
  fetchchapterbyuser,
  fetchMemberAttendanceById
} from "src/utils/common";
import Select from "react-select";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import { fetchChaptList, fetchMemberAttendanceByChepter } from "src/utils/common";
import moment from "moment";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import Modal from "@mui/material/Modal";
import {
  DeleteSharp,
  CalendarMonth,
  EditSharp,
  PlaylistAddCheckCircleIcon,
  RemoveRedEye,
  CheckCircleRounded,
  Cancel,
  CloseRounded,
  DownloadRounded
} from "@mui/icons-material";
import { CSVLink } from "react-csv";
import ChapterSelectDropDown from "src/components/ChapterSelectDropDown";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function ChapterAttendanceReport() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const memberActiveType = [
    { value: -1, label: "All" },
    { value: 1, label: "Active" },
    { value: 0, label: "De-Active" }
  ];
  const [chaptlist, setchaplist] = useState([]);
  const [myModal, setMyModal] = useState(false);
  const [memberFilter, setMemberFilter] = useState({ s_date: "", e_date: "" });
  const [memberFilterData, setMemberFilterData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // 0 = Total Meeting, 1 = As Member, 2 = As Chapter Director
  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : 0,

    chept_id: 0,
    mActive: -1,
    s_date: "",
    e_date: ""
  });
  const [memberdata, setmemberdata] = useState([]);
  const [adata, setadata] = useState([]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "min(900px, 94vw)",
    borderRadius: "16px",
    bgcolor: "background.paper",
    boxShadow: "0 20px 60px rgba(15, 23, 42, 0.28)",
    p: 0,
    overflow: "hidden",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column"
  };
  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  const memberFilterHandler = () => {
    setMemberFilterData(
      memberdata?.filter((item) =>
        moment(item?.date, "DD-MM-YYYY").isBetween(
          moment(memberFilter?.s_date, "DD-MM-YYYY"),
          moment(memberFilter?.e_date, "DD-MM-YYYY"),
          undefined,
          "[]"
        )
      )
    );
  };

  const fetchmemberattendace = async (m_id, s_date, e_date) => {
    const fndata = new FormData();
    fndata.append("m_id", m_id);
    // fndata.append("s_date", s_date);
    // fndata.append("e_date", e_date);
    const resp = await fetchMemberAttendanceById(fndata);
    if (resp.status == 1) {
      setActiveTab(0);
      setMyModal(true);
      setmemberdata(resp.data);
    }
  };
  const cancelModal = () => {
    setActiveTab(0);
    setMyModal(false);
  };
  const expo_columns = [
    { label: "No", key: "m_id" },
    { label: "Name", key: "m_name" },
    { label: "Total Meeting", key: "total" },
    { label: "Total Present", key: "present" },
    { label: "Total Absent", key: "absent" },
    { label: "Total Other Chapter Meeting", key: "total_other" },
    { label: "Total Other Chapter Present Meeting", key: "present_other" },
    { label: "Total Other Chapter Absent Meeting", key: "absent_other" }
  ];
  const columns = [
    {
      name: "No",
      selector: (row) => row.m_id,
      wrap: true,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row.m_name,
      sortable: true,
      width: "300px"
    },
    {
      name: "Total Meeting",
      wrap: true,
      width: "150px",
      selector: (row) => row.total,
      sortable: true
    },
    {
      name: "Total Present",
      wrap: true,
      width: "180px",
      selector: (row) => row.present,
      sortable: true
    },
    {
      name: "Total Absent",
      wrap: true,
      width: "180px",
      selector: (row) => row.absent,
      sortable: true
    },

    {
      name: "Total Meeting As Chapter Director",
      wrap: true,
      width: "250px",
      selector: (row) => row.total_other,
      sortable: true
    },
    {
      name: "Total Present As Chapter Director",
      wrap: true,
      width: "300px",
      selector: (row) => row.present_other,
      sortable: true
    },
    {
      name: "Total Absent As Chapter Director",
      wrap: true,
      width: "300px",
      selector: (row) => row.absent_other,
      sortable: true
    },

    {
      name: "Action",
      width: "70px",
      cell: (row) => (
        <>
          <a
            onClick={() => {
              fetchmemberattendace(row.m_id, searchdata?.s_date, searchdata?.e_date);
            }}
          >
            <Tooltip title="View Details">
              <IconButton>
                <RemoveRedEye color="info" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ];
  const handleSubmit = async () => {
    if (
      searchdata.chept_id == 0
      // || searchdata.e_date == "" || searchdata.s_date == ""
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
    } else {
      setIsLoading(true);
      setadata(await fetchMemberAttendanceByChepter(searchdata));
      setIsLoading(false);
    }
  };

  const ClearSearchResult = async () => {
    setsearchdata({
      chept_id: 0,
      mActive: -1,
      s_date: "",
      e_date: ""
    });
    setadata([]);
  };


  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  // Modal list source: date filter first, then the active tab.
  // attend_from comes from the API and tells the capacity the member attended in:
  // "As Member" (attended their own chapter as a member) or "As Director" (attended
  // a chapter where they hold a director post).
  const modalList = (memberFilterData?.length > 0 ? memberFilterData : memberdata || []).filter(
    (m) =>
      activeTab === 0 ||
      (activeTab === 1 && m.attend_from == "As Member") ||
      (activeTab === 2 && m.attend_from == "As Director")
  );

  // Header summary for the modal. Counts follow the active tab, so the Other Chapter
  // tab reports only that chapter's meetings.
  const memberInfo = memberdata?.[0] || {};
  const modalTotal = modalList.length;
  const modalPresent = modalList.filter((m) => m.status == 0).length;
  const modalAbsent = modalTotal - modalPresent;
  const modalPresentRate = modalTotal ? ((modalPresent / modalTotal) * 100).toFixed(1) : "0.0";
  const modalInitials = (memberInfo.m_name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  const selectedChapterName = chaptlist?.find((c) => c.chpt_id == searchdata.chept_id)?.chpt_name || "";

  // Per-member CSV export (modal view) — mirrors the on-screen meeting log.
  const modalCsvHeaders = [
    { label: "No", key: "sr_no" },
    { label: "Meeting Date", key: "date" },
    { label: "Chapter", key: "meeting_chpt_name" },
    { label: "Session ID", key: "session_id" },
    { label: "Status", key: "attend_type" }
  ];
  const modalCsvRows = modalList.map((m, ind) => ({
    sr_no: modalList.length - ind,
    date: m.date,
    meeting_chpt_name: m.meeting_chpt_name || "",
    session_id: `LVB-${m.meeting_id}`,
    attend_type: m.status == 0 ? "Present" : "Absent"
  }));

  return (
    <>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          .MuiModal-root, .MuiModal-root * { visibility: visible !important; }
          .MuiModal-root { position: absolute !important; inset: 0 !important; }
          .MuiDialog-container { position: static !important; }
          .MuiBox-root { box-shadow: none !important; }
        }
      `}</style>
      <Modal
        open={myModal}
        onClose={() => {
          cancelModal();
          setMemberFilterData([]);
          setMemberFilter({ s_date: "", e_date: "" });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          backdropFilter: "blur(4px)",
          "& .MuiModal-backdrop": { backgroundColor: "rgba(15, 23, 42, 0.6)" }
        }}
      >
        <Box sx={style}>
          {/* ---------- Header ---------- */}
          <Box
            sx={{
              px: 3,
              pt: 2.5,
              pb: 2,
              background: "linear-gradient(to bottom, #F8FAFC 0%, #FFFFFF 100%)",
              borderBottom: "1px solid #F1F5F9"
            }}
          >
            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.75 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "12px",
                    bgcolor: "#F1F5F9",
                    border: "1px solid #E2E8F0",
                    color: "primary.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 700,
                    fontSize: 18,
                    flexShrink: 0
                  }}
                >
                  {modalInitials || "NA"}
                </Box>
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                    <Typography
                      id="modal-modal-title"
                      component="h2"
                      sx={{ fontSize: { xs: 20, sm: 24 }, fontWeight: 700, color: "primary.main", letterSpacing: "-0.01em" }}
                    >
                      {memberInfo.m_name} {memberInfo.business_name ? `(${memberInfo.business_name})` : ""}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      mt: 0.5,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                      fontSize: { xs: 12, sm: 14 },
                      color: "text.secondary"
                    }}
                  >
                    <Box component="span" sx={{ fontWeight: 500, color: "#334155" }}>
                      Attendance Report
                    </Box>
                    <Box component="span" sx={{ width: 4, height: 4, borderRadius: "50%", bgcolor: "#CBD5E1" }} />
                    <Box component="span">{selectedChapterName || "All Chapters"}</Box>
                    <Box component="span" sx={{ width: 4, height: 4, borderRadius: "50%", bgcolor: "#CBD5E1" }} />
                    <Box component="span" sx={{ fontWeight: 500, color: "success.darker" }}>
                      {memberInfo.member_status == 1 ? "Active Member" : "De-Active Member"}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <IconButton
                aria-label="Close modal"
                onClick={cancelModal}
                sx={{ color: "#94A3B8", p: 1, borderRadius: "12px", mt: -1, mr: -1, "&:hover": { color: "#334155", bgcolor: "#F1F5F9" } }}
              >
                <CloseRounded fontSize="small" />
              </IconButton>
            </Box>

            {/* Summary stats */}
            <Grid container spacing={1.5} sx={{ mt: 2.5, pt: 2.5, borderTop: "1px solid #F1F5F9" }}>
              <Grid item xs={6} sm={3}>
                <Box sx={{ p: 1.5, bgcolor: "#F8FAFC", borderRadius: "12px", border: "1px solid #E2E8F0" }}>
                  <Typography
                    component="span"
                    sx={{ display: "block", fontSize: 11, fontWeight: 500, color: "#64748B", textTransform: "uppercase", letterSpacing: "0.06em" }}
                  >
                    Total Meetings
                  </Typography>
                  <Typography component="span" sx={{ display: "block", mt: 0.25, fontSize: 22, fontWeight: 700, color: "#1E293B" }}>
                    {modalTotal}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Box sx={{ p: 1.5, bgcolor: "rgba(84, 214, 44, 0.08)", borderRadius: "12px", border: "1px solid rgba(84, 214, 44, 0.2)" }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography
                      component="span"
                      sx={{ fontSize: 11, fontWeight: 500, color: "success.darker", textTransform: "uppercase", letterSpacing: "0.06em" }}
                    >
                      Present
                    </Typography>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "success.main" }} />
                  </Box>
                  <Typography component="span" sx={{ display: "block", mt: 0.25, fontSize: 22, fontWeight: 700, color: "success.darker" }}>
                    {modalPresent}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Box sx={{ p: 1.5, bgcolor: "rgba(255, 72, 66, 0.08)", borderRadius: "12px", border: "1px solid rgba(255, 72, 66, 0.2)" }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography
                      component="span"
                      sx={{ fontSize: 11, fontWeight: 500, color: "error.darker", textTransform: "uppercase", letterSpacing: "0.06em" }}
                    >
                      Absent
                    </Typography>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "error.main" }} />
                  </Box>
                  <Typography component="span" sx={{ display: "block", mt: 0.25, fontSize: 22, fontWeight: 700, color: "error.darker" }}>
                    {String(modalAbsent).padStart(2, "0")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Box
                  sx={{
                    p: 1.5,
                    bgcolor: "#F8FAFC",
                    borderRadius: "12px",
                    border: "1px solid #E2E8F0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography
                      component="span"
                      sx={{ fontSize: 11, fontWeight: 500, color: "#64748B", textTransform: "uppercase", letterSpacing: "0.06em" }}
                    >
                      Present Rate
                    </Typography>
                    <Typography component="span" sx={{ fontSize: 12, fontWeight: 700, color: "success.darker" }}>
                      {modalPresentRate}%
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 1, width: "100%", height: 8, borderRadius: "999px", bgcolor: "#E2E8F0", overflow: "hidden" }}>
                    <Box
                      sx={{
                        height: "100%",
                        borderRadius: "999px",
                        bgcolor: "success.main",
                        width: `${Math.min(parseFloat(modalPresentRate), 100)}%`,
                        transition: "width 300ms ease"
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* ---------- Body ---------- */}
          <Box sx={{ px: 3, py: 2.5, overflowY: "auto", flex: 1 }}>
            {/* Tabs + export actions */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
                pb: 2,
                mb: 2.5,
                borderBottom: "1px solid #E2E8F0"
              }}
            >
              <Box
                role="tablist"
                sx={{
                  display: "inline-flex",
                  p: 0.5,
                  bgcolor: "#F1F5F9",
                  borderRadius: "12px",
                  border: "1px solid rgba(226, 232, 240, 0.9)",
                  alignSelf: "flex-start"
                }}
              >
                {[
                  { label: "Total Meeting", value: 0 },
                  { label: "As Member", value: 1 },
                  { label: "As Chapter Director", value: 2 }
                ].map((t) => {
                  const selected = activeTab === t.value;
                  return (
                    <Box
                      key={t.value}
                      role="tab"
                      aria-selected={selected}
                      onClick={() => setActiveTab(t.value)}
                      sx={{
                        px: 2,
                        py: 0.75,
                        fontSize: { xs: 12, sm: 14 },
                        fontWeight: selected ? 600 : 500,
                        color: selected ? "primary.main" : "#475569",
                        bgcolor: selected ? "#FFFFFF" : "transparent",
                        borderRadius: "8px",
                        boxShadow: selected ? "0 1px 3px rgba(15, 23, 42, 0.12)" : "none",
                        cursor: "pointer",
                        transition: "all 150ms ease",
                        "&:hover": { color: selected ? "primary.main" : "#0F172A" }
                      }}
                    >
                      {t.label}
                    </Box>
                  );
                })}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CSVLink
                  data={modalCsvRows}
                  headers={modalCsvHeaders}
                  filename={`${(memberInfo.m_name || "member").replace(/\s+/g, "-")}-Attendance-Report.csv`}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<DownloadRounded sx={{ fontSize: 15 }} />}
                    sx={{
                      fontSize: 12,
                      fontWeight: 500,
                      color: "#475569",
                      borderColor: "#E2E8F0",
                      bgcolor: "#F8FAFC",
                      px: 1.5,
                      py: 0.75,
                      "&:hover": { borderColor: "primary.main", color: "primary.main", bgcolor: "#F1F5F9" }
                    }}
                  >
                    Export CSV
                  </Button>
                </CSVLink>
              </Box>
            </Box>

            {/* Filters */}
            <Box
              sx={{
                p: 1.75,
                bgcolor: "rgba(248, 250, 252, 0.85)",
                borderRadius: "12px",
                border: "1px solid #E2E8F0",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-end",
                gap: 1.5,
                mb: 2.5
              }}
            >
              <Box sx={{ flex: "1 1 180px", minWidth: 170 }}>
                <Typography component="label" htmlFor="modal-start-date" sx={{ display: "block", fontSize: 11, fontWeight: 600, color: "#475569", mb: 0.5 }}>
                  Start Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    id="modal-start-date"
                    name="s_date"
                    inputFormat="dd/MM/yyyy"
                    value={memberFilter?.s_date != "" ? moment(memberFilter?.s_date, "DD-MM-YYYY") : null}
                    onChange={(newDate) => {
                      setMemberFilter({
                        ...memberFilter,
                        s_date: newDate ? moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY") : ""
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{
                          fontSize: 13,
                          bgcolor: "#FFFFFF",
                          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                          "& input": { fontSize: 13, fontWeight: 500, py: 1 }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ flex: "1 1 180px", minWidth: 170 }}>
                <Typography component="label" htmlFor="modal-end-date" sx={{ display: "block", fontSize: 11, fontWeight: 600, color: "#475569", mb: 0.5 }}>
                  End Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    id="modal-end-date"
                    name="e_date"
                    inputFormat="dd/MM/yyyy"
                    value={memberFilter?.e_date != "" ? moment(memberFilter?.e_date, "DD-MM-YYYY") : null}
                    onChange={(newDate) => {
                      setMemberFilter({
                        ...memberFilter,
                        e_date: newDate ? moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY") : ""
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{
                          fontSize: 13,
                          bgcolor: "#FFFFFF",
                          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                          "& input": { fontSize: 13, fontWeight: 500, py: 1 }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, alignSelf: "flex-end" }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    if (memberFilter?.s_date != "" || memberFilter?.e_date != "") {
                      memberFilterHandler();
                    }
                  }}
                  sx={{ fontSize: 12, fontWeight: 600, px: 2.5, py: 1, borderRadius: "8px" }}
                >
                  Search
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setMemberFilterData([]);
                    setMemberFilter({ s_date: "", e_date: "" });
                  }}
                  sx={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: "#475569",
                    borderColor: "#CBD5E1",
                    bgcolor: "#FFFFFF",
                    px: 2.5,
                    py: 1,
                    borderRadius: "8px",
                    "&:hover": { borderColor: "#94A3B8", bgcolor: "#F1F5F9" }
                  }}
                >
                  Clear
                </Button>
              </Box>
            </Box>

            {/* Meeting log */}
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 1, mb: 1 }}>
                <Typography component="span" sx={{ fontSize: 12, fontWeight: 500, color: "#64748B" }}>
                  Detailed Meeting Log
                </Typography>
                <Typography component="span" sx={{ fontSize: 12, fontWeight: 500, color: "#64748B" }}>
                  Status Indicator
                </Typography>
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {modalList?.length > 0 ? (
                  modalList.map((m, ind) => {
                    const isPresent = m.status == 0;
                    return (
                      <Box
                        key={`${m.meeting_id}-${ind}`}
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          alignItems: { xs: "stretch", sm: "center" },
                          justifyContent: "space-between",
                          gap: 1.5,
                          p: 2,
                          bgcolor: "#FFFFFF",
                          borderRadius: "12px",
                          border: "1px solid #E2E8F0",
                          transition: "all 150ms ease",
                          "&:hover": { borderColor: "#CBD5E1", bgcolor: "#F8FAFC" }
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Box
                            sx={{
                              width: 28,
                              height: 28,
                              borderRadius: "8px",
                              bgcolor: "#F1F5F9",
                              color: "#475569",
                              fontSize: 12,
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}
                          >
                            {modalList.length - ind}
                          </Box>
                          <Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
                              <Typography component="span" sx={{ fontSize: 14, fontWeight: 600, color: "#1E293B" }}>
                                {m.date}
                              </Typography>
                              {m.meeting_chpt_name && (
                                <Box
                                  component="span"
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: 500,
                                    px: 1,
                                    py: 0.25,
                                    borderRadius: "4px",
                                    bgcolor: m.attend_from == "As Director" ? "#EFF4F8" : "#F1F5F9",
                                    color: m.attend_from == "As Director" ? "primary.main" : "#475569"
                                  }}
                                >
                                  {m.meeting_chpt_name}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "space-between", sm: "flex-end" }, gap: 1.5 }}>
                          <Typography component="span" sx={{ fontSize: 12, color: "#94A3B8", display: { xs: "inline", sm: "none" } }}>
                            Attendance
                          </Typography>
                          <Box
                            component="span"
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.75,
                              px: 1.5,
                              py: 0.75,
                              borderRadius: "999px",
                              fontSize: 12,
                              fontWeight: 600,
                              bgcolor: isPresent ? "rgba(84, 214, 44, 0.1)" : "rgba(255, 72, 66, 0.1)",
                              color: isPresent ? "success.darker" : "error.darker",
                              border: isPresent ? "1px solid rgba(84, 214, 44, 0.25)" : "1px solid rgba(255, 72, 66, 0.25)"
                            }}
                          >
                            {isPresent ? (
                              <CheckCircleRounded sx={{ fontSize: 15, color: "success.main" }} />
                            ) : (
                              <Cancel sx={{ fontSize: 15, color: "error.main" }} />
                            )}
                            {isPresent ? "Present" : "Absent"}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      p: 4,
                      textAlign: "center",
                      borderRadius: "12px",
                      border: "1px dashed #CBD5E1",
                      bgcolor: "#F8FAFC"
                    }}
                  >
                    <Typography sx={{ fontSize: 13, color: "#64748B" }}>
                      No meeting records found for the selected chapter and date range.
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          {/* ---------- Footer ---------- */}
          <Box
            sx={{
              px: 3,
              py: 2,
              bgcolor: "#F8FAFC",
              borderTop: "1px solid #E2E8F0",
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.5
            }}
          >
            <Typography component="p" sx={{ fontSize: 12, color: "#64748B", order: { xs: 2, sm: 1 } }}>
              Showing <Box component="span" sx={{ fontWeight: 600, color: "#334155" }}>{modalList.length}</Box> of{" "}
              <Box component="span" sx={{ fontWeight: 600, color: "#334155" }}>{memberdata?.length || 0}</Box> filtered meetings
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, order: { xs: 1, sm: 2 } }}>
              <Button
                variant="outlined"
                size="small"
                onClick={cancelModal}
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#475569",
                  borderColor: "#CBD5E1",
                  bgcolor: "#FFFFFF",
                  px: 2.5,
                  py: 1,
                  borderRadius: "8px",
                  "&:hover": { borderColor: "#94A3B8", bgcolor: "#F1F5F9" }
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Page title="Chapter's Attendance Report | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Chapter's Attendance Report
            </Typography>
          </Stack>

          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chept_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchdata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        chept_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chept_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchdata.chept_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Member Active Type</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        if (option.value == searchdata.mActive) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, mActive: e.value });
                    }}
                    options={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3} style={{ marginTop: "20px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata?.s_date != "" ? moment(searchdata?.s_date, "DD-MM-YYYY") : null
                      }
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          s_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid item xs={2}>
                <Stack spacing={3} style={{ marginTop: "20px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata?.e_date != "" ? moment(searchdata?.e_date, "DD-MM-YYYY") : null
                      }
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid xs={12} item sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="contained" style={{ margin: "0 10px" }} onClick={handleSubmit}>
                    Search
                  </Button>

                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px" }}>
            {adata && (
              <>
                <Button
                  className="btn btn-export"
                  sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}
                >
                  <CSVLink
                    data={adata}
                    headers={expo_columns}
                    filename={"Chapter's Attendance Report.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  title="Attendance History"
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={adata}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
}
